<template>
    <div class="stuff_board_course_card">
        <div class="stuff_board_course_card_top" v-for="course in followed_courses" :key="course.id">
            <div class="stuff_board_course_card_left">
                <router-link tag="img"
                             :to="{ name: 'course', params: {id: course.id} }"
                             :src="course.picture_url"
                             class="stuff_board_course_img">
                </router-link>
            </div>
            <div class="stuff_board_course_card_right">
                <router-link tag="span"
                             :to="{ name: 'course', params: {id: course.id} }"
                             class="stuff_board_course_name"
                >{{ course.name }}
                </router-link>
                {{course.description}}
            </div>
            <div class="stuff_board_course_card_right">
                <div>
                    <a v-if="course.is_follow" class="answer_span view_answer_span"
                       @click="_change_follow(course.id,false)"
                       style="text-decoration: underline;color: #66CCFF;padding-top: 18px;">取消收藏</a>
                    <a v-else class="answer_span view_answer_span"
                       @click="_change_follow(course.id,true)"
                       style="text-decoration: underline;color: #66CCFF;padding-top: 18px;">收藏</a>
                </div>
            </div>
        </div>
        <div class="stuff_board_course_card_end" v-if="show_q_r_content">
            <div class="stuff_board_course_arrow"
                 :style="{ right: arrow_right }"
            ></div>
            <div class="stuff_board_course_q_r_content">
                <!-- <Loading v-if="loading_state"></Loading> -->
                <v-loader :source="[course_report, course_question]">
                    <div class="course_card_report_content" v-if="q_r_transform==='r'">
                        <ReportItem class="course_report_item"
                                    v-for="(report, index) in course_report.results"
                                    :key="index"
                                    :data="report"
                        ></ReportItem>
                    </div>
                    <div class="course_card_question_content" v-if="q_r_transform==='q'">
                        <QaItem class="course_card_qa_item"
                                v-for="(question, index) in course_question.results"
                                :key="index"
                                :data="question"
                        ></QaItem>
                    </div>
                </v-loader>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        data: function () {
            return {
                collect_results: [],
            }
        },
        components: {},
        computed: {
            ...mapState({
                followed_courses: state => state.loginState.user_info.followed_courses,
            }),
            ...mapGetters({}),
        },
        methods: {
            ...mapActions({
                change_follow: 'course/change_follow',
                get_user_info: 'loginState/change_user_info',
            }),
            _change_follow: function (course_id, isFollow) {
                this.change_follow({
                    'is_follow': isFollow,
                    'id': course_id
                })
                let index
                for (let i = 0; i < this.followed_courses.length; i++) {
                    if (this.followed_courses[i].id === course_id) {
                        index = i
                        break
                    }
                }
                this.followed_courses[index].is_follow = isFollow

            }

        },
        mounted(){
            this.get_user_info()
        }

    }
</script>

<style scoped>
    .stuff_board_course_card {
        padding: 20px 0;
        border-bottom: 1px solid #eee;
    }

    .stuff_board_course_card_top {
        display: flex;
        margin-bottom: 30px;
    }

    .stuff_board_course_card_left {
        width: 33%;
        padding: 0 15px;
    }

    .stuff_board_course_img {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    /* */
    .stuff_board_course_card_right {
        display: flex;
        flex-direction: column;
        padding: 15px;
        width: 66%;
    }

    .stuff_board_course_name {
        display: inline-block;
        font-size: 16px;
        color: #666;
        margin-bottom: 20px;
    }


    /* */
    .stuff_board_course_card_right_end {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }


    .start_button {
        display: block;
        padding: 4px;
        font-size: 14px;
        color: #fff;
        background: #66CCFF;
        border: 1px solid #eee;
        text-align: center;
        border-radius: 28px;
        width: 130px;
        cursor: pointer;
    }

    /* */
    .stuff_board_course_card_end {
        width: 100%;
        margin-top: 20px;
        min-height: 80px;
        border: 1px solid #eee;
        position: relative;
    }

    .stuff_board_course_arrow {
        width: 0;
        height: 0;
        position: absolute;
    }

    .stuff_board_course_arrow:before {
        content: ' ';
        border: 15px solid #eee;
        border-color: transparent transparent #eee;
        position: absolute;
        top: -30px;
    }

    .stuff_board_course_arrow:after {
        content: ' ';
        border: 14px solid #fff;
        border-color: transparent transparent #fff;
        position: absolute;
        margin-left: 1px;
        top: -27px;
    }


    /* item */
    .course_card_report_content {
        display: flex;
        flex-wrap: wrap;
    }


    .course_card_question_content {
        display: flex;
        flex-direction: column;
    }


</style>